import React from 'react';

/**
 * Dress / clothing icon used by the Klær Level 1 row in CategoryMenu.
 * Sized by CSS (no width / height attributes) so the same component
 * works in the desktop topbar (20px) and could be re-used at other
 * sizes later. Fill inherits via the global `svg { fill: currentColor }`
 * rule in sanitize.css so the icon picks up the link's text color.
 */
const IconClothing = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    role="presentation"
    aria-hidden="true"
    {...props}
  >
    <path d="M13.86 14.333a.128.128 0 0 0-.008-.017L10.778 7.77l1.386-2.175a1.081 1.081 0 0 0 .007-1.125l-.02-.032-1.448-2.068V.7a.54.54 0 0 0-1.081 0v1.651l-.356.445a1.622 1.622 0 0 1-2.533 0l-.355-.445V.701a.54.54 0 0 0-1.082 0v1.67L3.85 4.437c-.007.01-.015.021-.02.032a1.081 1.081 0 0 0 .007 1.125L5.22 7.77l-3.074 6.546a1.081 1.081 0 0 0 .986 1.524h9.733c.776 0 1.3-.794.994-1.507ZM4.755 5.026l1.11-1.583.022.028a2.703 2.703 0 0 0 4.223 0l.022-.028 1.11 1.583L9.867 7.19H6.134ZM3.133 14.76 6.18 8.27h3.638l3.048 6.489Z" />
  </svg>
);

export default IconClothing;
